import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { withRouter } from 'react-router';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import React, { useState, useCallback } from 'react';

import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBox';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

import {
  getRandomNumberByInput,
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import { ExcludedNDCsDetailTableHead } from './gridComponents/ExTableHead';
import {
  ERRORMESSAGE_NDC_NOT_EMPTY,
  SUCCESSMESSAGE_GENERIC,
  ERR_NDC_NDC_HISTORY,
} from '../../../../SharedModules/Errors/constantMessageData';
import GridTableComponent from './gridComponents/ExTableGrid';
import FilterComponent from './ExNDCsSearch';
import {
  getCommonDropdownList,
  saveExcludedNDCsDetailList,
  getNDCsLidtByManufacturers,
  updateCodeTableDetails,
  getNDCsHistory,
  saveExcludedNDCsErrorMsgList,
  saveExcludedNDCsTableList,
  saveExcludedNDCsSearchTable,
  setExNDCsExtraState,
  saveExcludedNDCsSearch,
  updateFetchedNDCsValue,
  getNDCsListSearchByNameorNDCs,
} from '../store/actions';
import {
  fromQtrToDT,
  toQtrToDT,
} from '../../../../SharedModules/utilities/utilities';

function ExcludedNDCsDetails(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  // const getRebateProgramList = useSelector(
  //   (state) => state.sharedState.ExcludedNDCsReducer.dropdown
  // );
  const getSearchValue = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchValue
  );
  const getSearchValueTable = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.searchTable
  );

  const getNDCsModalTableList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsListForModal
  );
  const getNDCsList = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsDetailList
  );
  const saveNDCRes = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.saveNDC
  );

  const errorMessagesRedux = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.errorMessages
  );
  const extraState = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState
  );
  const edit = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.edit
  );
  const isCancel = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.isCancel
  );
  const showViewHistory = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.extraState.showViewHistory
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.ExcludedNDCsReducer.extraState.fullScreenView.ndcDetail
  );
  const getNDCsTableListRedux = useSelector(
    (state) => state.sharedState.ExcludedNDCsReducer.ndcsList
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const setState = (value) => dispatch(setExNDCsExtraState(value));
  const fetchAllNDCsListByManufacturers = (value) =>
    dispatch(getNDCsLidtByManufacturers(value));
  const setFilterValueTableAction = (value) =>
    dispatch(saveExcludedNDCsSearchTable(value));

  const setErrorMessagesRedux = (value) =>
    dispatch(saveExcludedNDCsErrorMsgList(value));

  const [excludedNDCs, setExcludedNDCs] = useState([]);
  const [filterModalView, setFilterModalView] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cancelView, setCancelView] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [saveView, setSaveView] = useState(false);
  const [errorField, setErrorField] = useState([]);
  const [totalResultCount, setTotalResultCount] = useState(0);
  const [rebateProList, setRebateProList] = useState([]);
  const [filterValue, setFilterValue] = useState({
    rebateProgram: '-1',
    action: '-1',
  });
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const setStateChange = (val) => {
    setState({
      ...extraState,
      ...val,
    });
  };

  React.useEffect(() => {
    setErrorMessagesRedux({
      ...errorMessagesRedux,
      detailPage: errorMessages,
    });
  }, [errorMessages]);

  React.useEffect(() => {
    const errMsg = errorMessagesRedux;
    const updateTabs = localStore;
    if (errMsg && Object.keys(errMsg).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/excludedNDCsDetail' && edit) {
            item.isFormDirty = true;
          } else {
            item.isFormDirty = false;
          }
          if (item.navTo === '/excludedNDCsDetail') {
            if (
              !_.isEmpty(errMsg?.detailPage) ||
              !_.isEmpty(errMsg?.detailTablePage)
            ) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [edit, errorMessagesRedux]);

  React.useEffect(() => {
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/excludedNDCsDetail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/excludedNDCsDetail' && item.isFormSave) {
          if (edit && _.isEmpty(errorField)) {
            onSave(true);
          }
        }
        return item;
      });
    }
  }, [localStore]);

  React.useEffect(() => {
    if (saveNDCRes && !_.isEmpty(saveNDCRes)) {
      setLoading(false);
      if (
        saveNDCRes &&
        saveNDCRes.message === 'SUCESS' &&
        saveNDCRes.status === '001'
      ) {
        if (saveNDCRes.data) {
          if (!_.isEmpty(saveNDCRes.data.saveExcludedNDCVOList)) {
            const newList = _.cloneDeep(getNDCsList?.updatedList);
            const orgList = _.cloneDeep(getNDCsList?.orgList);
            if (!_.isEmpty(newList)) {
              _.forEach(newList, (val) => {
                if (!val.excludedNdcSeqNum) {
                  const getData = _.filter(
                    saveNDCRes.data.saveExcludedNDCVOList,
                    (l) => l.drugSeqNum === val.drugSeqNum
                  );
                  if (!_.isEmpty(getData)) {
                    val.excludedNdcSeqNum = getData[0].excludedNdcSeqNum;
                  }
                }
                return val;
              });

              _.forEach(orgList, (val) => {
                const gd = _.filter(
                  newList,
                  (l) =>
                    l.drugSeqNum === val.drugSeqNum &&
                    l?.listIndex === val?.listIndex
                );
                if (!_.isEmpty(gd)) {
                  val.excludedNdcSeqNum = gd[0].excludedNdcSeqNum;
                  val.startQtr = gd[0].startQtr;
                  val.endQtr = gd[0].endQtr;
                  val.endQtr = gd[0].endQtr;
                  val.excludedNdcStatusCd = gd[0].excludedNdcStatusCd;
                }
                return val;
              });
              dispatch(
                saveExcludedNDCsDetailList({
                  orgList: orgList,
                  updatedList: newList,
                })
              );
            }
          }
        }
        setSuccessMessages([SUCCESSMESSAGE_GENERIC]);

        if (
          getSearchValue &&
          getSearchValue.chooseBy === 'NDC' &&
          getSearchValue.selectBy === 'NDC' &&
          getSearchValue.selection === 'Existing Rows'
        ) {
        
          dispatch(
            getNDCsListSearchByNameorNDCs(
              {
                searchBy: 'ndc',
                inputValue: getSearchValueTable.ndcsFilter,
                page: 0,
                pageSize: 1000,
                selection: 'Existing Rows',
                rebateProgramControl: getSearchValue.rebateProgram,
                pageFor: 'searchPage',
              },
              []
            )
          );
        }
     
      } else {
        setSuccessMessages([]);
        setErrorMessages([
          { message: 'Something went wrong. Data not saved successfully.' },
        ]);
      }
    }
  }, [saveNDCRes]);

  React.useEffect(() => {
    if (getSearchValue?.planType) {
      getCommonDropdownList(getSearchValue?.planType)
        .then((res) => {
          setLoading(false);
          setRebateProList(res);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [getSearchValue?.planType]);

  const changeQtrValue = (value) => {
    let qtr = null;
    if (value) {
      qtr = _.split(value, '');
      qtr = `${qtr[4]}q${_.split(value, '', 4)}`;
    }
    return qtr;
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  React.useEffect(() => {
    let list = [];
    if (!_.isEmpty(rebateProList)) {
      if (
        rebateProList.status === '001' &&
        rebateProList.message === 'SUCESS'
      ) {
        if (!_.isEmpty(rebateProList.data)) {
          list = _.map(rebateProList.data, (val, ind) => {
            return {
              ...val,
              id: val.rebateProgramCd,
              name: `${val.rebateProgramCd} | ${val.shortDescr}`,
              startQtr: changeQtrValue(val.startQtr),
              endQtr: changeQtrValue(val.endQtr),
            };
          });
        }
      }
    }
    setRebateProgramList(list);
  }, [rebateProList]);

  React.useEffect(() => {
    setFilterValue({
      rebateProgram: getSearchValue?.rebateProgram || -1,
      action: getSearchValue?.selection || -1,
    });
  }, [getSearchValue]);

  const changeFullScreenView = (tableName) => {
    const view = !fullScreenView;
    const dataSet = {
      ...extraState.fullScreenView,
      ndcDetail: view,
    };
    setStateChange({ fullScreenView: dataSet });
    localStorage.setItem('drawerIsOpen', !fullScreenView);
  };

  React.useEffect(() => {
    let detailList = [];
    const newGridList = _.cloneDeep(getNDCsList?.updatedList);
    if (!_.isEmpty(newGridList)) {
      detailList = newGridList
        ?.sort((a, b) => {
          return a.lastUpdateDt > b.lastUpdateDt ? -1 : 1;
        })
        ?.map((item) => {
          if (item.endQtr === '' || !item.endQtr) {
            item.newEndQtr = '4Q9999';
          } else {
            item.newEndQtr = item.endQtr;
          }
          return item;
        });
      detailList = _.map(detailList, (val, key) => {
        val.isErrorStartQtr = val.isErrorStartQtr || false;
        val.isErrorEndQtr = val.isErrorEndQtr || false;
        _.forEach(val, (v, k) => {
          if (k === 'startQtr' || k === 'endQtr') {
            const errorData = !_.isEmpty(errorMessagesRedux?.detailTablePage)
              ? _.filter(
                  errorMessagesRedux?.detailTablePage,
                  (l) => l.ndc === val.ndc && l.field === k
                )
              : [];
            val.isErrorStartQtr =
              k === 'startQtr' ? !_.isEmpty(errorData) : val.isErrorStartQtr;
            val.isErrorEndQtr =
              k === 'endQtr' ? !_.isEmpty(errorData) : val.isErrorEndQtr;
          }
          return val;
        });
        return val;
      });
      let errorMessagesArray = [];
      const tbdata = detailList;
      for (let i = 0; i < tbdata.length; i += 1) {
        for (let j = i + 1; tbdata.length > j; j += 1) {
          let iFromDt;
          let iToDt;
          let jFromDt;
          let jToDt;
          if (tbdata[i].startQtr && !tbdata[i].isErrorStartQtr)
            iFromDt = new Date(fromQtrToDT(tbdata[i].startQtr));
          if (tbdata[i].newEndQtr && !tbdata[i].isErrorEndQtr)
            iToDt = new Date(toQtrToDT(tbdata[i].newEndQtr));
          if (tbdata[j].startQtr && !tbdata[j].isErrorStartQtr)
            jFromDt = new Date(fromQtrToDT(tbdata[j].startQtr));
          if (tbdata[j].newEndQtr && !tbdata[j].isErrorEndQtr)
            jToDt = new Date(toQtrToDT(tbdata[j].newEndQtr));
          if (
            iFromDt &&
            iToDt &&
            jFromDt &&
            jToDt &&
            tbdata[j].ndc === tbdata[i].ndc
          ) {
            if (
              iFromDt <= jToDt &&
              jFromDt <= iToDt &&
              tbdata[j].ndc === tbdata[i].ndc
            ) {
              tbdata[i].isErrorStartQtr = true;
              tbdata[i].isErrorEndQtr = true;
              tbdata[j].isErrorStartQtr = true;
              tbdata[j].isErrorEndQtr = true;
              // errorMessagesArray.push(
              //   `Start and End Quarter overlap in row #${i + 1} and ${j + 1}`
              // );
              errorMessagesArray = [
                {
                  startQtr: true,
                  field: 'startQtr',
                  errorType: 'Validation',
                  ndc: tbdata[i].ndc,
                  listIndex: tbdata[i].listIndex,
                  viewMessage: true,
                  errorTitle: `For NDC ${tbdata[i].ndc}`,
                  message: `Start and End Quarter overlap in row #${
                    i + 1
                  } and ${j + 1}`,
                },
              ];
              updateSetFieldErrors(errorMessagesArray);
            }
          } else if (
            tbdata[j].ndc === tbdata[i].ndc &&
            iFromDt &&
            iToDt &&
            jFromDt &&
            !jToDt
          ) {
            if (
              tbdata[j].ndc === tbdata[i].ndc &&
              jFromDt > iFromDt &&
              jFromDt < iToDt
            ) {
              tbdata[i].isErrorStartQtr = true;
              tbdata[i].isErrorEndQtr = true;
              tbdata[j].isErrorStartQtr = true;
              // errorMessagesArray.push(
              //   `Start and End Quarter overlap in row #${i + 1} and ${j + 1}`
              // );
              errorMessagesArray = [
                {
                  startQtr: true,
                  field: 'startQtr',
                  errorType: 'Validation',
                  ndc: tbdata[i].ndc,
                  listIndex: tbdata[i].listIndex,
                  viewMessage: true,
                  errorTitle: `For NDC ${tbdata[i].ndc}`,
                  message: `Start and End Quarter overlap in row #${
                    i + 1
                  } and ${j + 1}`,
                },
              ];
              updateSetFieldErrors(errorMessagesArray);
            }
          } else if (
            tbdata[j].ndc === tbdata[i].ndc &&
            iFromDt &&
            !iToDt &&
            jFromDt &&
            jToDt
          ) {
            if (
              tbdata[j].ndc === tbdata[i].ndc &&
              iFromDt > jFromDt &&
              iFromDt < jToDt
            ) {
              tbdata[i].isErrorStartQtr = true;
              tbdata[j].isErrorStartQtr = true;
              tbdata[j].isErrorEndQtr = true;
              // errorMessagesArray.push(
              //   `Start and End Quarter overlap in row #${i + 1} and ${j + 1}`
              // );
              errorMessagesArray = [
                {
                  startQtr: true,
                  field: 'startQtr',
                  errorType: 'Validation',
                  ndc: tbdata[i].ndc,
                  listIndex: tbdata[i].listIndex,
                  viewMessage: true,
                  errorTitle: `For NDC ${tbdata[i].ndc}`,
                  message: `Start and End Quarter overlap in row #${
                    i + 1
                  } and ${j + 1}`,
                },
              ];
              updateSetFieldErrors(errorMessagesArray);
            }
          }
        }
      }
      if (errorMessagesArray.length) detailList = tbdata;
    }
    setLoading(false);
    setExcludedNDCs(detailList);
  }, [filterModalView, getNDCsList?.updatedList]);

  const excludedNDCsDetailList = useCallback(() => {
    if (getSearchValue && getSearchValueTable) {
      if (getSearchValueTable.listFor === 'Labeler') {
        const filter = {};
        filter.rebateProgramControl = getSearchValue.rebateProgram;
        if (getSearchValue.allManufacturers) {
          filter.allManufacturersChecked = true;
        } else {
          filter.labelerCodes = _.map(
            getSearchValueTable.manufacturers,
            'labelerCode'
          );
          filter.allManufacturersChecked = false;
        }
        fetchAllNDCsListByManufacturers(filter);
      }
      setLoading(false);
    }
  }, [getSearchValue]);

  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => {
        return x.navTo === '/excludedNDCsDetail' && x.isRefresh;
      }).length > 0
    ) {
      const newObj = localStore.map((item) => {
        if (item.navTo === '/excludedNDCsDetail') {
          item.isRefresh = false;
        }
        return item;
      });

      excludedNDCsDetailList();
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [localStore, getSearchValue]);

  const changeSearchValue = () => {
    dispatch(saveExcludedNDCsSearch(extraState?.oldSearchVal));
    setStateChange({
      oldSearchVal: null,
      searchValueChange: false,
      serachValForModal: false,
    });
  };

  const onSelectNDCFromModal = useCallback(() => {
    setSuccessMessages([]);
    let viewPage = false;
    const searchValue = getSearchValueTable;
    let oldGrid = [];
    if (getNDCsList) {
      oldGrid = getNDCsList?.orgList ? getNDCsList?.orgList : [];
    }
    const stateValue = {
      ...searchValue,
    };
    if (_.isEmpty(getNDCsModalTableList?.ndcsRight)) {
      setErrorMessages([{ message: ERRORMESSAGE_NDC_NOT_EMPTY }]);
    } else {
      viewPage = true;
    }
    if (viewPage) {
      let cloneList = _.cloneDeep(getNDCsModalTableList?.ndcsRight);
      cloneList = _.map(cloneList, (item) => {
        const val = _.cloneDeep(item);
        const listIndex = getRandomNumberByInput(1)[0];
        val.listIndex = listIndex;
        val.lastUpdateDt = val?.lastUpdateDt || null;
        return val;
      });
      const newGrid = oldGrid;
      const updatedList = getNDCsList.updatedList
        ? _.concat(getNDCsList.updatedList, cloneList)
        : cloneList;
      stateValue.ndcsRight = [];
      setErrorMessages([]);
      setFilterValueTableAction(stateValue);
      dispatch(
        saveExcludedNDCsDetailList({
          orgList: newGrid,
          updatedList: updatedList,
        })
      );
      changeSearchValue();
      // dispatch(updateFetchedNDCsValue([]));
      // setNDCsTableListAction({ ndcsLeft: [], ndcsRight: [] });
      setStateChange({ refExNDCList: true, isCancel: true });
      setFilterModalView(false);
    }
  }, [getSearchValueTable, getNDCsModalTableList, getNDCsList]);

  const getShowViewHistoryPlan = () => {
    if (!_.isEmpty(selectedRow) && !_.isNull(selectedRow?.excludedNdcSeqNum)) {
      setErrorMessages([]);
      setStateChange({ showViewHistory: true });
    } else {
      setErrorMessages([
        {
          message: _.isEmpty(selectedRow)
            ? ERRORMESSAGE_NDC_NOT_EMPTY
            : ERR_NDC_NDC_HISTORY,
        },
      ]);
    }
  };

  // React.useEffect(() => {
  //   setLoading(false);
  // }, [fethNDCsHistory]);

  const resetTableField = () => {
    // setExcludedNDCs([]);
    setLoading(true);
    setStateChange({ edit: false, isCancel: false });
    const detailList = getNDCsList?.orgList ? getNDCsList?.orgList : [];
    const resetList = _.map(getNDCsList?.updatedList, (val) => {
      val.startQtr = val.oldStartQtr;
      val.endQtr = val.oldEndQtr;
      return val;
    });
    setErrorMessagesRedux({
      ...errorMessagesRedux,
      detailPage: [],
      detailTablePage: [],
    });
    setErrorField([]);
    dispatch(
      saveExcludedNDCsDetailList({
        orgList: resetList,
        updatedList: detailList,
      })
    );
    setCancelView(false);

    const updateTabs = localStore;
    const newObj1 =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/excludedNDCsDetail') {
          item.isFormSave = false;
          item.isFormDirty = false;
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
    setLoading(false);
  };

  const getOrgListWithQtr = (list) => {
    return _.map(list, (val) => {
      const startQtr = val?.startQtr ? getQtrVal(val.startQtr) : null;
      const endQtr = val?.endQtr ? getQtrVal(val.endQtr) : null;
      const oldStartQtr = val?.oldStartQtr ? getQtrVal(val.oldStartQtr) : null;
      const oldEndQtr = val?.oldEndQtr ? getQtrVal(val.oldEndQtr) : null;
      return {
        ...val,
        // excludedNdcStatusCd:
        //   val.excludedNdcStatusCd === 1 ? 'Valid' : 'Invalid',
        startQtr: startQtr,
        endQtr: endQtr,
        oldStartQtr: oldStartQtr,
        oldEndQtr: oldEndQtr,
      };
    });
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getLisSendToAPI = (list, listFor) => {
    let newList = list.map((val, ind) => ({
      excludedNdcSeqNum: val.excludedNdcSeqNum ? val.excludedNdcSeqNum : null,
      drugSeqNum: val.drugSeqNum,
      rebateProgramCd: val.rebateProgramCd
        ? val.rebateProgramCd
        : getSearchValue.rebateProgram,
      labelerCode: val.labelerCode || val.ndc.split('-')[0],
      lastUpdateUserId: logInUser,
      startQtr: val.startQtr,
      endQtr: val.endQtr || '',
      excludedNdcStatusCd: val.excludedNdcStatusCd,
      oldStartQtr: val.oldStartQtr,
      oldEndQtr: val.oldEndQtr,
    }));
    if (listFor === 'deletedList') {
      newList = _.filter(newList, (l) => l.excludedNdcSeqNum && l);
    }
    return newList;
  };

  const qtrWithQ = (qtr) => {
    if (qtr) {
      let newQtr = _.split(qtr, '');
      newQtr = `${newQtr[4]}Q${_.join(_.split(qtr, '', 4), '')}`;
      return newQtr;
    }
    return null;
  };

  const addQinQtrValue = (list) => {
    return _.map(list, (val) => ({
      ...val,
      startQtr: qtrWithQ(val.startQtr),
      endQtr: qtrWithQ(val.endQtr),
      oldStartQtr: qtrWithQ(val.oldStartQtr),
      oldEndQtr: qtrWithQ(val.oldEndQtr),
    }));
  };

  const checkDublicate = (orgList, list) => {
    const filterList = orgList.filter(
      (l) => l.ndc === list.ndc && l.listIndex !== list.listIndex
    );
    return filterList.filter((val) => {
      if (!_.isEmpty(val.startQtr) && !_.isEmpty(val.endQtr)) {
        if (
          (_.gte(list.startQtr, val.startQtr) &&
            _.lt(list.startQtr, val.endQtr)) ||
          (_.lt(val.startQtr, list.endQtr) && _.gte(val.endQtr, list.endQtr))
        ) {
          return val;
        }
      }
    });
  };

  const onSave = (isClose) => {
    setLoading(true);
    setErrorMessages([]);
    setStateChange({ edit: false, isCancel: false });
    setSaveView(false);
    const error = [];
    const error1 = [];
    const error2 = [];
    const orgList = getOrgListWithQtr(_.cloneDeep(getNDCsList?.updatedList));
    const deletedList = getNDCsList?.deletedList || [];
    const list = orgList.map((val, ind) => {
      const checkList = orgList.filter(
        (l) => l.ndc === val.ndc && l.listIndex !== val.listIndex
      );
      if (!_.isEmpty(val.startQtr) && !_.isEmpty(val.endQtr)) {
        let checkPass = false;
        checkPass = checkDublicate(orgList, val);
        if (!_.isEmpty(checkPass)) {
          error.push(val);
        }
      }
      if (_.isEmpty(val.startQtr)) {
        error1.push(val);
      }
      if (checkList.length > 1 && _.isEmpty(val.endQtr)) {
        error2.push(val);
      }
    });
    if (_.isEmpty(error) && _.isEmpty(error1) && _.isEmpty(error2)) {
      let updateList = [];
      let validCheck = [];
      if (orgList && !_.isEmpty(orgList)) {
        updateList = _.filter(
          orgList,
          (l) => l.startQtr !== l.oldStartQtr || l.endQtr !== l.oldEndQtr
        );
        validCheck = _.filter(
          updateList,
          (l) => l.excludedNdcStatusCd === 'Invalid'
        );
      }
      if (!_.isEmpty(validCheck)) {
        setLoading(false);
        setErrorMessages([
          { message: `NDC ${_.join(validCheck.ndc, ', ')} is not valid.` },
        ]);
      } else {
        setLoading(true);
        updateList = addQinQtrValue(updateList);
        let dList = !_.isEmpty(deletedList)
          ? getOrgListWithQtr(_.cloneDeep(deletedList))
          : [];
        dList = addQinQtrValue(dList);
        const request = {
          saveExcludedNDCVOList: getLisSendToAPI(updateList, 'updateList'),
          deleteNDCExcludedVOList:
            dList && !_.isEmpty(dList)
              ? getLisSendToAPI(dList, 'deletedList')
              : [],
        };
        dispatch(
          updateCodeTableDetails(
            request,
            getNDCsTableListRedux,
            filterValue.action
          )
        );
        if (isClose) {
          closeTab('/excludedNDCsDetail', history);
        }
      }
    } else {
      setLoading(false);
      const errList = [];
      if (!_.isEmpty(error)) {
        const errorNdc = _.uniq(_.map(error, (l) => l.ndc));
        errList.push({
          message: `NDC ${_.join(errorNdc, ', ')} period overlaps.`,
        });
      }
      if (!_.isEmpty(error1)) {
        const errorNdc1 = _.uniq(_.map(error1, (l) => l.ndc));
        errList.push({
          message: `NDC ${_.join(errorNdc1, ', ')} start quarter is empty.`,
        });
      }
      if (!_.isEmpty(error2)) {
        const errorNdc2 = _.uniq(_.map(error2, (l) => l.ndc));
        errList.push({
          message: `NDC ${_.join(errorNdc2, ', ')} end quarter is empty.`,
        });
      }
      setErrorMessages(errList);
      // setErrorMessages([`NDC ${_.join(errorNdc, ', ')} period overlaps.`]);
      // setErrorMessages([
      //   `NDC ${_.join(errorNdc1, ', ')} start or end quarter is empty.`,
      // ]);
    }
  };

  const getQtrVal = (value) => {
    if (value) {
      const newValue = value?.toLowerCase();
      let newVal = newValue?.split('q');
      if (value.length <= 4) {
        let curtYears = moment().format('YYYY');
        curtYears = `${_.join(_.split(curtYears, '', 2), '')}${newVal[1]}`;
        newVal = `${curtYears}${newVal[0]}`;
      } else {
        newVal = newVal[1] + newVal[0];
      }
      return newVal;
    }
  };

  const validateQtr = (curtCol, qtr1, qtr2) => {
    let pass = false;
    if (qtr2 && !_.isEmpty(qtr2)) {
      const otQtrVal = getQtrVal(qtr2);
      if (curtCol === 'startQtr') {
        pass = _.lte(qtr1, otQtrVal);
      } else {
        pass = _.gte(qtr1, otQtrVal);
      }
    } else {
      pass = true;
    }
    return pass;
  };

  const checkQtrValidation = useCallback(
    (cellInfo) => {
      const deletedList = getNDCsList?.deletedList || [];
      const allData = cellInfo?.node?.parent?.allLeafChildren;
      const newList = allData ? _.map(allData, (val) => val.data) : [];
      if (!_.isEmpty(newList)) {
        const updateList = _.filter(
          newList,
          (l) => l.startQtr !== l.oldStartQtr || l.endQtr !== l.oldEndQtr
        );
        if (!_.isEmpty(deletedList) || !_.isEmpty(updateList)) {
          setStateChange({ edit: true, isCancel: true });
          // } else {
          //   setStateChange({ edit: false, isCancel: false });
        }
      }
      const p = {
        force: cellInfo.data,
      };
      cellInfo.api.refreshCells(p);
      setSuccessMessages([]);
      setErrorMessages([]);
    },
    [getNDCsList]
  );

  const updateSetFieldErrors = (v) => {
    const errFld = _.unionWith(
      [...v] || [],
      errorMessagesRedux?.detailTablePage || [],
      _.isEqual
    );
    setErrorMessagesRedux({
      ...errorMessagesRedux,
      detailTablePage: [...errFld],
    });
    setErrorMessages([]);
    setSuccessMessages([]);
    setErrorField([...errFld]);
  };

  const addNDCsActionBtn = React.useCallback(() => {
    // setNDCsTableListAction({ ndcsLeft: [], ndcsRight: [] });
    const newData = _.cloneDeep(getSearchValue);
    setStateChange({
      callLebelerAPI: true,
      clearNDCLeft: true,
      serachValForModal: true,
      oldSearchVal: newData,
    });
    setFilterModalView(true);
    const newVal = {
      ...newData,
      chooseBy: 'NDC',
      selectBy: 'Labeler',
    };
    // setFilterValue(newVal);
    dispatch(saveExcludedNDCsSearch(newVal));
  }, [getSearchValue]);

  return (
    <div
      className="excludedNDCs tBillPanel padding-0"
      data-testid="excludedNDCs-detail-list-component"
    >
      <Spinner load={spinnerLoader} />
      <div className="tabs-container">
        {!fullScreenView && (
          <CustomSeparator parent1="Maintain" parent2="Excluded NDCs Detail" />
        )}
        <DisplaySuccessMessages successMessages={successMessages} />
        <DisplayErrorMessages
          errorMessages={
            errorMessagesRedux?.detailPage?.length > 0
              ? [
                  ...new Set(
                    _.map(errorMessagesRedux?.detailPage, (l) => l.message)
                  ),
                ]
              : []
          }
        />
        <DisplayErrorMessages
          errorMessages={
            errorMessagesRedux?.detailTablePage?.length > 0
              ? [
                  ...new Set(
                    _.map(errorMessagesRedux?.detailTablePage, (l) => l.message)
                  ),
                ]
              : []
          }
        />
        {!fullScreenView && (
          <div className="no-margin" data-testid="ndc-detail-search-panel">
            <div className="row mb-2">
              <div
                className="col-4 col-sm-6 col-md-6 col-lg-4"
                key="rebateProgram"
              >
                <SelectBoxComponent
                  labelName="Rebate Program"
                  required
                  reqColor
                  disabled
                  showSelectOne={false}
                  optionList={rebateProgramList}
                  defaultValue={filterValue.rebateProgram}
                />
              </div>

              <div
                className="col-4 col-sm-6 col-md-6 col-lg-4"
                key="NDCsAction"
              >
                <SelectBoxComponent
                  labelName="Selection"
                  required
                  reqColor
                  disabled
                  optionList={[
                    { id: 'Existing Rows', name: 'Existing' },
                    { id: 'Any Rows', name: 'Any' },
                  ]}
                  defaultValue={filterValue.action}
                />
              </div>

              <div
                className="col-4 col-sm-12 col-md-12 col-lg-4 my-sm-3 my-lg-0 pl-0"
                kry="btn1"
              >
                <fieldset className="btnFields">
                  <div className="btn-wrapper">
                    <Button
                      className="mx-0 btn btn-success btn-save btn-primary"
                      data-testid="visible-save-modal"
                      onClick={() => setSaveView(true)}
                      disabled={!edit || !_.isEmpty(errorField)}
                    >
                      <SVGComponent iconName="Icon-awesome-save" /> Save
                    </Button>
                    <Button
                      className="btn btn-cancel btn btn-primary"
                      data-testid="visible-cancel-modal"
                      onClick={() => setCancelView(true)}
                      disabled={!isCancel}
                    >
                      <SVGComponent iconName="Icon-cancel" /> Cancel
                    </Button>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        )}

        <div className="table-with-edited-textbox excludendc-table">
          <GridTableComponent
            data={
              excludedNDCs
                ? _.orderBy(excludedNDCs, ['ndc'], ['asc'])
                : excludedNDCs
            }
            cellHead={ExcludedNDCsDetailTableHead}
            gridHeight={fullScreenView ? '70vh' : 400}
            rowSelection="single"
            onSelect={(e) => setSelectedRow(e.data)}
            tableHeader
            filterIcon
            isFilter
            historyIcon
            handleViewHistoryPlan={getShowViewHistoryPlan}
            actionIcon
            addRowsView
            addNDCsAction={addNDCsActionBtn}
            fullScreenIcon
            setFullScreenView={() =>
              changeFullScreenView('Excluded NDCs Details')
            }
            onCellValueChanged={checkQtrValidation}
            singleClickEdit
            errorField={errorField}
            setErrorField={setErrorField}
            // setExcludedNDCs={setExcludedNDCs}
            setLoading={setLoading}
            getQtrVal={getQtrVal}
            getNDCsList={getNDCsList}
            validateQtr={validateQtr}
            fullScreenView={fullScreenView}
            setEdit={(e) => setStateChange({ edit: e, isCancel: e })}
            fullScreenViewTable="Excluded NDCs Details"
            fileName="Excluded NDCs"
            setTotalResultCount={setTotalResultCount}
            updateSetFieldErrors={updateSetFieldErrors}
            setSuccessMessages={setSuccessMessages}
            data-testid="exluded-ndc-table-action-call"
          />
          <p className="total-results" tabIndex="0">
            Total Results:
            <b>{totalResultCount?.toLocaleString('en-US')}</b>
          </p>
        </div>

        {filterModalView && (
          <CommonModal
            className="frr-dialog-css dialog-900"
            open={filterModalView}
            viewAction
            viewHeader
            onOk={onSelectNDCFromModal}
            okTitle="Yes"
            onClose={() => {
              changeSearchValue();
              setFilterModalView(false);
            }}
            closeTitle="No"
            modalTitle="Search Excluded NDCs"
            childrenComponent={
              <div id="ndcPopupModalExcluded">
              <FilterComponent
                pageFor="detailFilter"
                viewFilter={[
                  'planType',
                  'selection',
                  'rebateProgram',
                  'chooseBy',
                ]}
              />
            </div>
            }
          />
        )}
        

        {cancelView && (
          <CommonModal
            className="frr-dialog-css dialog-420"
            open={cancelView}
            viewAction
            viewHeader
            onOk={resetTableField}
            okTitle="Yes"
            onClose={() => setCancelView(false)}
            closeTitle="No"
            modalTitle="Cancel"
            childrenComponent="There are unsaved changes. Do you want to continue?"
          />
        )}

        {saveView && (
          <CommonModal
            className="frr-dialog-css dialog-420"
            open={saveView}
            viewAction
            viewHeader
            onOk={() => onSave(false)}
            okTitle="Yes"
            onClose={() => setSaveView(false)}
            closeTitle="No"
            modalTitle="Save"
            childrenComponent="Are you sure you want to Save your changes? To revert changes, click on Cancel"
          />
        )}

        {showViewHistory ? (
          <ViewHistoryComponent
            setShowViewHistory={() =>
              setStateChange({ showViewHistory: !showViewHistory })
            }
            tableName="EXCLUDED_NDC"
            keyValue={{ EXCLUDED_NDC_SEQ_NUM: selectedRow?.excludedNdcSeqNum }}
            columnNames="START_QTR,END_QTR,EXCLUDED_NDC_STATUS_CD"
          />
        ) : null}
      </div>
    </div>
  );
}
export default withRouter(ExcludedNDCsDetails);
